<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="searchListWrap">
          <div class="searchList">
            <div class="center_text">
            <h5 class="period">조회기간</h5>
              <div class="inBtnWrap">
                <h5 class="period date" v-if="IsWhole">전체조회기간입니다.</h5>
                <h5 class="period date" v-else>{{dateStart}}<b>-</b>{{dateEnd}}</h5>
                <div class="inBtn pre red">
                  <router-link to="./checkupDate">
                    <button type="button" class="search function">조회하기</button>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="card_wrap">
              <div class="card_list" v-for="c in getCheckupList" :key="c.id" :class="{blue : c.categoryCode === 1, red : c.categoryCode === 0}">
                <div class="cl_title">
                  <h2 class="white">{{c.category}}검사</h2>
                  <div class="cl_btn">
                    <button type="button" @click.prevent="goDetail(c.categoryCode, c.id, c.checkupDate)">결과보기</button>
                  </div>
                </div>
                <div class="cl_content black">
                  <div class="content_item one">
                    <div class="ci_title">
                      <label>검사일</label>
                    </div>
                    <div class="ci_content">
                      <p>{{c.checkupDate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="listEmpty" v-if="!firstDataSet">
            <div class="imgWrap">
              <img src="@/assets/images/error.svg">
            </div>
            <div class="ct_content">
              <p>검사결과가 아직 나오지 않았거나 </p>
              <p>검사내역이 존재하지 않습니다.</p>
            </div>
            <div class="ct_content small">
              <span>*병리검사는 업무일 기준 7일 소요,</span>
              <span>혈액검사는 업무일 기준 1-2일이 소요됩니다.</span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '검사결과 내역'
      },
      dataFlag: false,
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      monthDate: '',
      today: '',
      firstDataSet: false,
      listData: '',
      setCount: false
    }
  },
  computed: {
    ...mapGetters('checkup', [
      'getCheckupList',
      'getCheckupDate'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_CAUSE_AUTHERROR'
    ]),
    ...mapMutations('checkup', [
      'SET_CHECKUP',
      'SET_CHECKUP_LIST_DATA',
      'SET_CHECKUP_DATE'
    ]),
    ...mapActions('checkup', [
      'CHECKUP_LIST',
      'CHECKUP_DETAIL'
    ]),
    async goDetail (code, id, date) {
      try {
        const requestData = {
          categoryCode: code,
          checkupCode: id,
          checkupDate: date
        }
        // 디테일에서 루프돌리기 위해서 이미불러온 리스트 값을 옮겨감
        this.SET_CHECKUP(requestData)
        // 디테일 조회
        await this.CHECKUP_DETAIL(requestData)
          .then(() => {
            this.$router.push(`./checkupDetail/${id}`)
          })
      } catch (error) {
        console.log('error :', error);
        console.log('검사결과조회 리스트-  상세보기 클릭시 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    // 오늘 -7일전 ~ 오늘 날짜 조회
    getDefaultDate () {
      let date = new Date()
      let monthDate = date.getTime() - (7 * 24 * 60 * 60 * 1000)
      // const year = date.getFullYear()
      // const month = date.getMonth() + 1
      // let dateMutated = new Date(year, month, 0)

      date = this.$moment(date).format('YYYY-MM-DD')
      monthDate = this.$moment(monthDate).format('YYYY-MM-DD')
      // dateMutated = this.$moment(dateMutated).format('YYYY-MM-DD')

      this.monthDate = monthDate
      this.today = date
    },
    async fetchData () {
      console.log('체크리스트 실행 진입')
      try {
        let requestData
        if (this.dataFlag === false) {
          requestData = {
            gte: null,
            lte: null,
            default: true
          }
        } else {
          requestData = {
            gte: this.dateStart,
            lte: this.dateEnd,
            default: this.IsWhole
          }
        }
        await this.CHECKUP_LIST(requestData)
          .then(() => this.carryData())
      } catch (error) {
        console.log('error :', error);
        console.log('체크리스트 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    carryData () {
      if (this.getCheckupList.length >= 1) {
        this.firstDataSet = true
      } else {
        this.firstDataSet = false
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (this.getCheckupDate.length >= 1) {
      this.dataFlag = true
      this.dateStart = this.getCheckupDate[0]
      this.dateEnd = this.getCheckupDate[1]
      this.IsWhole = this.getCheckupDate[2]
    } else {
      this.IsWhole = true
      this.dataFlag = false
    }
    this.fetchData()
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    if (this.getCheckupDate.length >= 1) {
      this.SET_CHECKUP_DATE('')
      this.dataFlag = false
    }
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
